<template>
  <div class="apartment-selector" role="group" aria-label="Ferienwohnung wählen">
    <button
      v-for="apartment in apartments"
      :key="apartment._id"
      type="button"
      class="apartment-selector__option"
      :class="{ 'apartment-selector__option--active': apartment.slug === selectedApartment }"
      :aria-pressed="apartment.slug === selectedApartment"
      @click="setSelectedApartment(apartment.slug)"
    >
      {{ apartment.name }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    selectedApartment: String,
    apartments: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:selectedApartment'],
  setup(props, { emit }) {
    const setSelectedApartment = (slug) => {
      emit('update:selectedApartment', slug)
    }

    return {
      setSelectedApartment
    }
  }
}
</script>

<style scoped lang="scss">
.apartment-selector {
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;
  padding: 0.25rem;
  border-radius: 999px;
  background: rgba(81, 90, 95, 0.06);
  border: 1px solid rgba(81, 90, 95, 0.1);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.04);
}

.apartment-selector__option {
  appearance: none;
  border: 0;
  margin: 0;
  padding: 0.625rem 1.35rem;
  border-radius: 999px;
  background: transparent;
  color: #515a5f;
  font: inherit;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  line-height: 1.2;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover:not(.apartment-selector__option--active) {
    color: #2f363a;
    background: rgba(255, 255, 255, 0.65);
  }

  &:focus-visible {
    outline: 2px solid rgba(66, 217, 228, 0.65);
    outline-offset: 2px;
  }

  &--active {
    background: #42d9e4;
    color: #fff;
    box-shadow: 0 4px 14px rgba(66, 217, 228, 0.35);
    cursor: default;
  }
}

@media (max-width: 768px) {
  .apartment-selector {
    width: 100%;
    justify-content: stretch;
  }

  .apartment-selector__option {
    flex: 1 1 0;
    min-width: 0;
    padding: 0.7rem 0.75rem;
    font-size: 0.75rem;
    letter-spacing: 0.06em;
    white-space: normal;
  }
}
</style>
